import type { IconProps } from './types/types';
import IconWrapper from './wrapper/SvgIconWrapper';

const SharpIcon = (props: IconProps) => {
  return (
    <IconWrapper {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.55542 4.88875C1.55542 4.76602 1.65491 4.66653 1.77764 4.66653H14.2221C14.3448 4.66653 14.4443 4.76602 14.4443 4.88875V5.77764C14.4443 5.90037 14.3448 5.99986 14.2221 5.99986H1.77764C1.65491 5.99986 1.55542 5.90037 1.55542 5.77764V4.88875Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.55542 10.2221C1.55542 10.0994 1.65491 9.99986 1.77764 9.99986H14.2221C14.3448 9.99986 14.4443 10.0994 14.4443 10.2221V11.111C14.4443 11.2337 14.3448 11.3332 14.2221 11.3332H1.77764C1.65491 11.3332 1.55542 11.2337 1.55542 11.111V10.2221Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1677 1.63204C12.21 1.68071 12.229 1.7453 12.2199 1.80907L10.4421 14.2535C10.4264 14.363 10.3327 14.4443 10.2221 14.4443H9.3332C9.26878 14.4443 9.20753 14.4164 9.16532 14.3677C9.12311 14.319 9.1041 14.2544 9.11321 14.1907L10.891 1.74622C10.9066 1.63674 11.0004 1.55542 11.111 1.55542L11.9999 1.55542C12.0643 1.55542 12.1255 1.58338 12.1677 1.63204Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.83441 1.63204C6.87662 1.68071 6.89563 1.7453 6.88652 1.80907L5.10874 14.2535C5.0931 14.363 4.99934 14.4443 4.88875 14.4443H3.99986C3.93544 14.4443 3.87419 14.4164 3.83198 14.3677C3.78978 14.319 3.77076 14.2544 3.77987 14.1907L5.55765 1.74622C5.57329 1.63674 5.66705 1.55542 5.77764 1.55542L6.66653 1.55542C6.73095 1.55542 6.7922 1.58338 6.83441 1.63204Z"
      />
    </IconWrapper>
  );
};

export default SharpIcon;
